var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightGreenSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15px",
    height: "15px",
    fill: "rgb(0 175 140)",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 94 94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.042c0 0.528 -0.429 0.957 -0.957 0.957H0.957c-0.528 0 -0.957 -0.429 -0.957 -0.957V0.957c0 -0.528 0.427 -0.957 0.957 -0.957h13.085c0.528 0 0.957 0.429 0.957 0.957V14.042z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGreenSquare);
export default __webpack_public_path__ + "static/media/lightGreenSquare.757fffeaafd5e2e648605ae55009f7a8.svg";
export { ForwardRef as ReactComponent };